import React, { useState, useEffect } from "react";
import EditDocForm from "../components/EditDocForm";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function EditDocumentPage() {
  const { i18n } = useTranslation();

  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [savedLanguage, setSaveLanguage] = useState();
  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);
  return (
    <div className="md:flex md:justify-center">
      <div className="p-3 md:w-deflaut md:flex">
        <div className="w-full">
          <a href="/DocCenter" className="no-underline">
            <p className="no-underline text-header text-ft-light hover:text-ft font-bold">
              {savedLanguage === "en"
                ? location.state.event.titleEng
                : savedLanguage === "cn"
                  ? location.state.event.titleCn
                  : location.state.event.titleHk}
            </p>
          </a>
          <EditDocForm
            documentCenterList={
              location.state !== null ? location.state.event : ""
            }
          />
        </div>
      </div>
    </div>
  );
}

export default EditDocumentPage;
